import { CustomAction } from 'model/state';
import {
  FETCH_ALERTS_BY_LOCATION, FETCH_ALERTS_BY_LOCATION_SUCCESS, FETCH_ALERTS_BY_LOCATION_ERROR, SELECT_ALL_ALERTS,
  SELECT_ALERT_ROW, UPDATE_ALERT_SEARCH, FETCH_ALERTS_BY_USER, FETCH_ALERTS_BY_USER_SUCCESS, FETCH_ALERTS_BY_USER_ERROR,
  INCREMENT_ALERT_PAGE, REINIT_ALERT_PAGE_COUNT, SET_CURRENT_ALERT, CLEAR_ALERT, CLEAR_ALERT_SUCCESS, CLEAR_ALERT_ERROR,
  CLEAR_BULK_ALERTS, CLEAR_BULK_ALERTS_SUCCESS, CLEAR_BULK_ALERTS_ERROR, UPDATE_ALERT_FILTER,
  FETCH_ALERT_EXPORT_CSV_DATA, FETCH_ALERT_EXPORT_CSV_DATA_ERROR, CLEAR_ALERT_EXPORT_CSV_DATA, FETCH_ALERT_EXPORT_CSV_DATA_SUCCESS,
  FETCH_ALARM_LIST, FETCH_ALARM_LIST_SUCCESS, FETCH_ALARM_LIST_ERROR, CLEAR_CRITICAL_ALERT
} from 'constants/ActionTypes';
import { AlarmLabel, Alert, AlertActionFilter, AlertFilter, Alerts, AlertTotals } from 'model';


/**
 * Payload
 */
export interface AlertPayload {
  locationId?: string;
  alerts?: Alert[];
  selectAll?: boolean;
  select?: boolean;
  alertId?: string;
  search?: string;
  userId?: string;
  filter?: AlertFilter;
  alertList?: Alerts;
  totals?: AlertTotals;
  currentAlert?: Alert | null;
  alert?: Alert;
  partialFilters?: Partial<AlertActionFilter>;
  alarmList?: AlarmLabel[];
  snoozeSeconds?: number;
  exportCsvData?: string | null;
  pendingAlerts?: Alert[];
  feedbackType?: string;
}

/**
 * Actions
 */
export const fetchAlertsByLocation = (locationId: string): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALERTS_BY_LOCATION,
    payload: { locationId }
  };
};

export const fetchAlertsByLocationSuccess = (alerts: Alert[], pendingAlerts: Alert[]): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALERTS_BY_LOCATION_SUCCESS,
    payload: { alerts, pendingAlerts }
  };
};

export const fetchAlertsByLocationError = (): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALERTS_BY_LOCATION_ERROR,
  };
};

export const setSelectAllAlerts = (selectAll: boolean): CustomAction<AlertPayload> => {
  return {
    type: SELECT_ALL_ALERTS,
    payload: { selectAll }
  };
};

export const setSelectAlertRow = (select: boolean, alertId: string): CustomAction<AlertPayload> => {
  return {
    type: SELECT_ALERT_ROW,
    payload: { select, alertId }
  };
};

export const updateAlertSearch = (search: string): CustomAction<AlertPayload> => {
  return {
    type: UPDATE_ALERT_SEARCH,
    payload: { search }
  };
};

export const fetchAlertsByUserId = (userId: string, filter: AlertFilter): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALERTS_BY_USER,
    payload: { userId, filter }
  };
};

export const fetchAlertsByUserIdSuccess = (alertList: Alerts, totals: AlertTotals | undefined): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALERTS_BY_USER_SUCCESS,
    payload: { alertList, totals  }
  };
};

export const fetchAlertsByUserIdError = (): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALERTS_BY_USER_ERROR,
  };
};

export const incrementAlertPage = (): CustomAction<AlertPayload> => {
  return {
    type: INCREMENT_ALERT_PAGE,
  };
};

export const reinitAlertPageCount = (): CustomAction<AlertPayload> => {
  return {
    type: REINIT_ALERT_PAGE_COUNT,
  };
};

export const setCurrentAlert = (currentAlert: Alert | null): CustomAction<AlertPayload> => {
  return {
    type: SET_CURRENT_ALERT,
    payload: { currentAlert }
  };
};

export const clearAlert = (alert: Alert, snoozeSeconds: number = 0): CustomAction<AlertPayload> => {
  return {
    type: CLEAR_ALERT,
    payload: { alert, snoozeSeconds }
  };
};

export const clearCriticalAlertAndSubmitFeedback = (alert: Alert, feedbackType: string): CustomAction<AlertPayload> => {
  return {
    type: CLEAR_CRITICAL_ALERT,
    payload: { alert, feedbackType }
  };
};

export const clearAlertSuccess = (alert: Alert): CustomAction<AlertPayload> => {
  return {
    type: CLEAR_ALERT_SUCCESS,
    payload: { alert }
  };
};

export const clearAlertError = (): CustomAction<AlertPayload> => {
  return {
    type: CLEAR_ALERT_ERROR,
  };
};

export const clearBulkAlerts = (): CustomAction<AlertPayload> => {
  return {
    type: CLEAR_BULK_ALERTS,
  };
};

export const clearBulkAlertsSuccess = (alerts: Alert[]): CustomAction<AlertPayload> => {
  return {
    type: CLEAR_BULK_ALERTS_SUCCESS,
    payload: { alerts }
  };
};

export const clearBulkAlertsError = (): CustomAction<AlertPayload> => {
  return {
    type: CLEAR_BULK_ALERTS_ERROR,
  };
};

export const updateAlertFilters = (filters: Partial<AlertActionFilter>): CustomAction<AlertPayload> => {
  return {
    type: UPDATE_ALERT_FILTER,
    payload: { partialFilters: filters }
  };
};

export const fetchAlarmList = (): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALARM_LIST,
  };
};

export const fetchAlarmListSuccess = (alarmList: AlarmLabel[]): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALARM_LIST_SUCCESS,
    payload: { alarmList }
  };
};

export const fetchAlarmListError = (): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALARM_LIST_ERROR,
  };
};

export const fetchAlertExportCsvData = (userId: string, filter: Partial<AlertActionFilter>): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALERT_EXPORT_CSV_DATA,
    payload: {
      userId,
      filter
    }
  };
};

export const fetchAlertExportCsvDataError = (): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALERT_EXPORT_CSV_DATA_ERROR,
    payload: {}
  };
};

export const fetchAlertExportCsvDataSuccess = (exportCsvData: string): CustomAction<AlertPayload> => {
  return {
    type: FETCH_ALERT_EXPORT_CSV_DATA_SUCCESS,
    payload: {
      exportCsvData
    }
  };
};

export const clearAlertExportCsvData = (): CustomAction<AlertPayload> => {
  return {
    type: CLEAR_ALERT_EXPORT_CSV_DATA,
    payload: {}
  }
}
